module.exports = __webpack_public_path__ + "static/media/arrow-submit.c13849db.png";